var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCameraProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "25px",
    viewBox: "0 0 31 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCameraProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M146,338.2 C144.0116,338.2 142.4,339.81232 142.4,341.8 C142.4,343.7884 144.0116,345.4 146,345.4 C147.98792,345.4 149.6,343.7884 149.6,341.8 C149.6,339.81232 147.98792,338.2 146,338.2 Z M156.56,333.7375 L153.392,333.7375 C152.9564,333.7375 152.487008,333.4015 152.349464,332.990425 L151.530536,330.546812 C151.392464,330.136 150.9236,329.8 150.488,329.8 L141.512,329.8 C141.0764,329.8 140.607008,330.136 140.469464,330.547075 L139.650536,332.990687 C139.512464,333.4015 139.0436,333.7375 138.608,333.7375 L135.44,333.7375 C133.988,333.7375 132.8,334.91875 132.8,336.3625 L132.8,348.175 C132.8,349.61875 133.988,350.8 135.44,350.8 L156.56,350.8 C158.012,350.8 159.2,349.61875 159.2,348.175 L159.2,336.3625 C159.2,334.91875 158.012,333.7375 156.56,333.7375 Z M146,348.4 C142.354952,348.4 139.4,345.445048 139.4,341.8 C139.4,338.155216 142.354952,335.2 146,335.2 C149.64452,335.2 152.6,338.155216 152.6,341.8 C152.6,345.445048 149.64452,348.4 146,348.4 Z M155.9,338.2 C155.4032,338.2 155,337.797314 155,337.3 C155,336.8032 155.4032,336.4 155.9,336.4 C156.397314,336.4 156.8,336.8032 156.8,337.3 C156.8,337.797314 156.397057,338.2 155.9,338.2 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-11.4%",
    y: "-14.3%",
    width: "122.7%",
    height: "128.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Misc-Discover-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Open-profile-web-version-Copy-4",
    transform: "translate(-131.000000, -328.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icCameraProfile"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCameraProfile);
export default __webpack_public_path__ + "static/media/icCameraProfile.7c20ea9377edc5bddd25ecb4f3754834.svg";
export { ForwardRef as ReactComponent };